<template>
  <div class="underlined-title border-hr-container">
    <component
      :is="tagTitle"
      :class="[{'title': includeDefaultStyle }, tagClass]"
    >
      {{ title }}
    </component>
    <span :class="['border-hr', 'border-bottom', `border-${borderColor}`]"><hr></span>
  </div>
</template>

<script>
export default {
  name: 'UnderlinedTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    borderColor: {
      type: String,
      default: 'green'
    },
    tagTitle: {
      type: String,
      default: 'h2'
    },
    tagClass: {
      type: String,
      default: ''
    },
    includeDefaultStyle: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="less" scoped>
@import (reference) "~@less/shared/utilities.less";
@colors: red, orange, yellow, green, turquoise, blue, violet, pink;
@length : length(@colors);
.color-loop(@colors; @length) when ( @length > 0 ) {
  .color-loop(@colors, @length - 1 );
  @color: extract(@colors, @length);
  @colorVar: 'nfb-@{color}';

  .border-@{color} {
    background-color: @@colorVar;
  }
};
.color-loop(@colors, @length);
.title {
  text-transform: uppercase;
  font-family: @font-family-semi-bold;
  margin-bottom: 1rem;
  font-weight: normal;
  &.h4 {
    font-size: 1.5rem;
  }
  &.h5 {
    font-size: 1rem;
  }
}
</style>
